
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "52px",
    "height": "40px",
    "viewBox": "0 0 52 40",
    "enable-background": "new 0 0 52 40",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "rect",
      "attrsMap": {
        "display": "none",
        "fill": "#999999",
        "width": "52",
        "height": "40"
      }
    },
    {
      "tag": "g",
      "children": [
        {
          "tag": "g",
          "children": [
            {
              "tag": "path",
              "attrsMap": {
                "fill": "#FFFFFF",
                "d": "M2.703,31.29l0.563-0.703c0.718,0.5,1.374,1.001,1.969,1.5c-0.281,0.281-0.501,0.532-0.656,0.75\r\n\t\t\tC3.671,32.024,3.046,31.509,2.703,31.29z M3.078,38.228c0.405-1.249,0.797-2.702,1.172-4.359c0.312,0.125,0.609,0.251,0.891,0.375\r\n\t\t\tc-0.375,1.438-0.75,2.859-1.125,4.266L3.078,38.228z M3.172,28.29l0.563-0.609c0.312,0.251,0.75,0.609,1.313,1.078\r\n\t\t\tc0.249,0.219,0.437,0.392,0.563,0.516c-0.251,0.251-0.485,0.469-0.703,0.656C4.093,29.118,3.515,28.571,3.172,28.29z\r\n\t\t\t M6.828,33.353h0.844c0,1.625-0.126,2.766-0.375,3.422c-0.251,0.656-0.813,1.281-1.688,1.875c-0.188-0.251-0.375-0.5-0.563-0.75\r\n\t\t\tc0.75-0.438,1.219-0.938,1.406-1.5C6.702,35.868,6.828,34.853,6.828,33.353z M5.844,28.946h3.516\r\n\t\t\tc-0.126-0.312-0.36-0.733-0.703-1.266L9.5,27.306c0.469,0.75,0.718,1.203,0.75,1.359l-0.563,0.281h3.938v0.797H8.75l0.563,0.328\r\n\t\t\tc-0.626,0.72-1.266,1.359-1.922,1.922c0.469-0.03,1.219-0.063,2.25-0.094c0.844-0.03,1.468-0.047,1.875-0.047\r\n\t\t\tc-0.375-0.469-0.72-0.844-1.031-1.125l0.703-0.516c0.938,0.969,1.749,1.845,2.438,2.625c-0.251,0.157-0.516,0.345-0.797,0.563\r\n\t\t\tc-0.063-0.094-0.173-0.234-0.328-0.422c-0.126-0.156-0.234-0.281-0.328-0.375c-0.094,0-0.251,0-0.469,0\r\n\t\t\tc-2.156,0.063-3.673,0.141-4.547,0.234c-0.188,0-0.422,0.031-0.703,0.094c-0.094,0.031-0.173,0.047-0.234,0.047l-0.375-0.844\r\n\t\t\tc0.281-0.156,0.546-0.328,0.797-0.516c0.78-0.656,1.39-1.281,1.828-1.875H5.844V28.946z M8.938,33.353h0.844v5.016H8.938V33.353z\r\n\t\t\t M11.094,33.353h0.797v3.75c0,0.281,0.171,0.422,0.516,0.422h0.234c0.312,0,0.483-0.125,0.516-0.375\r\n\t\t\tc0.062-0.563,0.094-1.094,0.094-1.594c0.249,0.125,0.53,0.234,0.844,0.328c-0.032,0.563-0.094,1.031-0.188,1.406\r\n\t\t\tc-0.126,0.687-0.516,1.031-1.172,1.031h-0.422c-0.813,0-1.219-0.359-1.219-1.078V33.353z"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "fill": "#FFFFFF",
                "d": "M16.438,38.415h-0.891v-9.234h3.469c0.124-0.499,0.218-1.078,0.281-1.734l0.938,0.094\r\n\t\t\tc-0.032,0.094-0.063,0.251-0.094,0.469c-0.094,0.532-0.173,0.922-0.234,1.172h5.25v7.828c0.03,0.906-0.422,1.359-1.359,1.359\r\n\t\t\tc-0.688,0-1.235,0-1.641,0c-0.063-0.345-0.126-0.656-0.188-0.938c0.312,0.03,0.827,0.047,1.547,0.047\r\n\t\t\tc0.563,0.03,0.812-0.157,0.75-0.563v-6.891h-7.828V38.415z M18.031,31.665h4.688v4.219h-4.688V31.665z M18.875,32.462v2.578h2.953\r\n\t\t\tv-2.578H18.875z"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "fill": "#FFFFFF",
                "d": "M28.953,27.399l0.938,0.047c-0.188,0.375-0.392,0.734-0.609,1.078h3.328v0.703h-2.719\r\n\t\t\tc0.124,0.125,0.343,0.345,0.656,0.656c0.124,0.157,0.218,0.266,0.281,0.328l-0.656,0.516c-0.032-0.03-0.063-0.063-0.094-0.094\r\n\t\t\tc-0.313-0.405-0.595-0.75-0.844-1.031l0.516-0.375h-0.984c-0.469,0.594-0.938,1.078-1.406,1.453\r\n\t\t\tc-0.157-0.188-0.36-0.405-0.609-0.656C27.718,29.274,28.452,28.4,28.953,27.399z M31.672,30.071l0.75-0.281\r\n\t\t\tc0.124,0.188,0.281,0.469,0.469,0.844c0.03,0.094,0.062,0.157,0.094,0.188h4.547v1.734h-0.844v-1.031h-8.672v1.031h-0.797v-1.734\r\n\t\t\th4.828C31.953,30.571,31.827,30.322,31.672,30.071z M28.531,32.368h7.641v2.438h-6.844v0.797h7.078v2.953h-0.844v-0.469h-6.234\r\n\t\t\tv0.469h-0.797V32.368z M29.328,33.071v1.078h6v-1.078H29.328z M35.563,36.306h-6.234v1.078h6.234V36.306z M33.969,27.399\r\n\t\t\tl0.938,0.047c-0.063,0.188-0.188,0.453-0.375,0.797c-0.063,0.125-0.11,0.219-0.141,0.281H38v0.703h-2.906\r\n\t\t\tc0.124,0.125,0.312,0.313,0.563,0.563c0.188,0.219,0.312,0.359,0.375,0.422l-0.656,0.516c-0.032-0.03-0.094-0.109-0.188-0.234\r\n\t\t\tc-0.063-0.094-0.313-0.405-0.75-0.938l0.516-0.328h-0.938c-0.22,0.375-0.469,0.703-0.75,0.984\r\n\t\t\tc-0.188-0.188-0.407-0.375-0.656-0.563C33.172,28.993,33.624,28.243,33.969,27.399z"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "fill": "#FFFFFF",
                "d": "M38.938,35.556c1.905-0.499,3.437-1.281,4.594-2.344c-0.032-0.063-0.094-0.156-0.188-0.281\r\n\t\t\tc-0.094-0.094-0.173-0.171-0.234-0.234c-1.125,0.75-2.376,1.329-3.75,1.734c-0.157-0.218-0.328-0.484-0.516-0.797\r\n\t\t\tc1.655-0.375,3.188-1.062,4.594-2.063h-3.094v-0.75h8.109v0.75h-3.844c-0.281,0.219-0.563,0.453-0.844,0.703\r\n\t\t\tc0.437,0.438,0.78,0.938,1.031,1.5c1.28-0.625,2.421-1.234,3.422-1.828l0.563,0.75c-0.72,0.375-1.453,0.75-2.203,1.125\r\n\t\t\tc0.563,1.5,1.702,2.531,3.422,3.094c-0.251,0.219-0.485,0.484-0.703,0.797c-1.688-0.687-2.845-1.875-3.469-3.563\r\n\t\t\tc-0.063,0.031-0.173,0.094-0.328,0.188c-0.157,0.063-0.281,0.125-0.375,0.188c0.188,0.532,0.281,1.095,0.281,1.688\r\n\t\t\tc0.062,1.5-0.642,2.233-2.109,2.203c-0.438,0.03-0.813,0.047-1.125,0.047c-0.063-0.313-0.126-0.626-0.188-0.938\r\n\t\t\tc0.188,0.03,0.624,0.047,1.313,0.047c0.874,0.063,1.296-0.391,1.266-1.359c0-0.281-0.032-0.563-0.094-0.844\r\n\t\t\tc-1.188,1.188-2.906,2.156-5.156,2.906c-0.094-0.219-0.251-0.5-0.469-0.844c2.25-0.593,4.046-1.563,5.391-2.906\r\n\t\t\tc-0.094-0.25-0.204-0.469-0.328-0.656c-1.188,1.063-2.688,1.875-4.5,2.438C39.28,36.088,39.125,35.837,38.938,35.556z\r\n\t\t\t M43.672,27.681l0.844-0.281c0.062,0.125,0.155,0.328,0.281,0.609c0.155,0.345,0.265,0.609,0.328,0.797l-0.516,0.141h4.969v1.922\r\n\t\t\th-0.844v-1.125h-8.719v1.125h-0.844v-1.922h5.063C44.047,28.415,43.859,27.993,43.672,27.681z"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "children": [
        {
          "tag": "g",
          "children": [
            {
              "tag": "g",
              "children": [
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "fill": "#FFFFFF",
                        "d": "M2.133,22.648v-1.716c1.418,0,2.573-1.155,2.573-2.575v-3.662h1.718v3.662\r\n\t\t\t\t\tC6.424,20.724,4.498,22.648,2.133,22.648z"
                      }
                    }
                  ]
                },
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "fill": "#FFFFFF",
                        "d": "M14.8,22.648c-2.366,0-4.29-1.925-4.29-4.291v-3.662h1.715v3.662c0,1.42,1.154,2.575,2.575,2.575V22.648\r\n\t\t\t\t\tz"
                      }
                    }
                  ]
                },
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "fill": "#FFFFFF",
                        "d": "M16.027,22.648v-1.716c3.021,0,5.482-2.46,5.482-5.483h1.717C23.227,19.419,19.996,22.648,16.027,22.648\r\n\t\t\t\t\tz"
                      }
                    }
                  ]
                },
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "fill": "#FFFFFF",
                        "d": "M16.027,15.924v-1.716c3.021,0,5.482-2.46,5.482-5.483h1.717C23.227,12.695,19.996,15.924,16.027,15.924\r\n\t\t\t\t\tz"
                      }
                    }
                  ]
                },
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "fill": "#FFFFFF",
                        "d": "M16.027,9.199V7.483c3.021,0,5.482-2.459,5.482-5.483h1.717C23.227,5.971,19.996,9.199,16.027,9.199z"
                      }
                    }
                  ]
                },
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "rect",
                      "attrsMap": {
                        "x": "7.564",
                        "y": "12.75",
                        "fill": "#FFFFFF",
                        "width": "1.715",
                        "height": "10.207"
                      }
                    }
                  ]
                },
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "rect",
                      "attrsMap": {
                        "x": "2.922",
                        "y": "11.728",
                        "fill": "#FFFFFF",
                        "width": "11",
                        "height": "1.717"
                      }
                    }
                  ]
                },
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "fill": "#FFFFFF",
                        "d": "M12.154,4.574H2.949V2.859h9.205c0.473,0,0.858-0.387,0.858-0.859h1.716\r\n\t\t\t\t\tC14.729,3.421,13.574,4.574,12.154,4.574z"
                      }
                    }
                  ]
                },
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "rect",
                      "attrsMap": {
                        "x": "7.486",
                        "y": "5.822",
                        "fill": "#FFFFFF",
                        "width": "1.715",
                        "height": "4.723"
                      }
                    }
                  ]
                },
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "rect",
                      "attrsMap": {
                        "x": "3.885",
                        "y": "5.822",
                        "fill": "#FFFFFF",
                        "width": "1.717",
                        "height": "4.723"
                      }
                    }
                  ]
                },
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "rect",
                      "attrsMap": {
                        "x": "11.088",
                        "y": "5.822",
                        "fill": "#FFFFFF",
                        "width": "1.717",
                        "height": "4.723"
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tag": "g",
              "children": [
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "fill": "#FFFFFF",
                        "d": "M49.037,22.535c-2.365,0-4.291-1.926-4.291-4.293v-0.787h1.715v0.787c0,1.421,1.154,2.576,2.576,2.576\r\n\t\t\t\t\tV22.535z"
                      }
                    }
                  ]
                },
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "fill": "#FFFFFF",
                        "d": "M37.303,22.535v-1.717c1.42,0,2.575-1.155,2.575-2.576v-0.787h1.716v0.787\r\n\t\t\t\t\tC41.594,20.609,39.671,22.535,37.303,22.535z"
                      }
                    }
                  ]
                },
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "rect",
                      "attrsMap": {
                        "x": "31.637",
                        "y": "2.681",
                        "fill": "#FFFFFF",
                        "width": "1.717",
                        "height": "18.767"
                      }
                    }
                  ]
                },
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "fill": "#FFFFFF",
                        "d": "M44.863,10.881H44.52c-1.419,0-2.574-1.154-2.574-2.573V2.681h1.717v5.627\r\n\t\t\t\t\tc0,0.473,0.385,0.858,0.857,0.858h0.344c0.475,0,0.858-0.386,0.858-0.858V2.681h1.717v5.627\r\n\t\t\t\t\tC47.438,9.727,46.283,10.881,44.863,10.881z"
                      }
                    }
                  ]
                },
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "fill": "#FFFFFF",
                        "d": "M34.212,22.42h-6.237v-1.717h6.237c0.472,0,0.857-0.385,0.857-0.857v-1.373h1.717v1.373\r\n\t\t\t\t\tC36.786,21.266,35.631,22.42,34.212,22.42z"
                      }
                    }
                  ]
                },
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "rect",
                      "attrsMap": {
                        "x": "37.387",
                        "y": "4.598",
                        "fill": "#FFFFFF",
                        "width": "11.844",
                        "height": "1.716"
                      }
                    }
                  ]
                },
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "rect",
                      "attrsMap": {
                        "x": "37.424",
                        "y": "14.896",
                        "fill": "#FFFFFF",
                        "width": "11.844",
                        "height": "1.716"
                      }
                    }
                  ]
                },
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "rect",
                      "attrsMap": {
                        "x": "42.278",
                        "y": "15.51",
                        "fill": "#FFFFFF",
                        "width": "1.717",
                        "height": "7.197"
                      }
                    }
                  ]
                },
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "fill": "#FFFFFF",
                        "d": "M49.258,13.97h-7.329c-1.894,0-3.433-1.54-3.433-3.433V2.681h1.717v7.856\r\n\t\t\t\t\tc0,0.945,0.77,1.715,1.716,1.715h7.329V13.97z"
                      }
                    }
                  ]
                },
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "fill": "#FFFFFF",
                        "d": "M30.465,16.813c-1.42,0-2.574-1.153-2.574-2.574V7.371c0-1.418,1.154-2.573,2.574-2.573h1.799v1.716\r\n\t\t\t\t\th-1.799c-0.474,0-0.858,0.387-0.858,0.857v6.867c0,0.474,0.385,0.858,0.858,0.858V16.813z"
                      }
                    }
                  ]
                },
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "fill": "#FFFFFF",
                        "d": "M34.346,16.813h-1.863v-1.716h1.863c0.473,0,0.857-0.385,0.857-0.858V7.371\r\n\t\t\t\t\tc0-0.471-0.385-0.857-0.857-0.857V4.798c1.419,0,2.574,1.155,2.574,2.573v6.867C36.92,15.659,35.765,16.813,34.346,16.813z"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  